export const personalWidgetTypes = {};

export const projWidgetTypes = {
  SAFETY_COMMENTS_RAISED: "SAFETY_COMMENTS_RAISED",
  STAFF_ASSIGNMENTS: "STAFF_ASSIGNMENTS",
  ADR_STATUS: "ADR_STATUS",
  PAYMENTS: "PAYMENTS"
};
